/* RESPONSIBLE TEAM: team-ai-insights */

import type { ProjectedConversationsRanking } from 'embercom/lib/suggestions/constants';
import { type EntityType } from 'embercom/models/data/entity-types';
import { type Status } from 'embercom/models/data/content-service/content-review-statuses';
import type ContentWrapper from 'embercom/models/content-service/content-wrapper';
import type { InterfaceIconName } from '@intercom/pulse/lib/interface-icons';
import type TaskSuggestion from 'embercom/models/content-service/task-suggestion';
import type { TaskSuggestionStatus } from 'embercom/models/content-service/task-suggestion';

export enum OptimizeSuggestionSortBy {
  Impact = 'impact',
  Date = 'date',
}

export enum OptimizeSuggestionType {
  ContentGap = 'content-gap',
  DataGap = 'data-gap',
  ActionGap = 'action-gap',
}

export type OptimizeSuggestionFilterState = {
  suggestionTypes?: OptimizeSuggestionType[];
  date?: string;
  topics?: string[];
  sortBy?: OptimizeSuggestionSortBy;
  impactFilter?: ProjectedConversationsRanking[];
};

export type OptimizeSuggestionItem = {
  entityId: string;
  contentType?: EntityType;
  suggestionType: OptimizeSuggestionType;
  suggestionTypeDisplay: string;
  title: string;
  description: string;
  createdAt: string;
  conversationIds: string[];
  suggestionState: Status | TaskSuggestionStatus;
  topicList: string[];
  subtopicList: string[];
  impactRanking: ProjectedConversationsRanking;
  suggestion: ContentWrapper | TaskSuggestion;
  icon: InterfaceIconName;
};
